module.exports = __webpack_public_path__ + "static/media/photo134.07b83829.jpg";